import { useEffect, useState } from "react";
import { isDebugOn, debugLogs, onDebugLogs, type DebugEntry } from "../lib/debug";

export default function DebugBanner() {
  const [logs, setLogs] = useState<DebugEntry[]>(debugLogs);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const unsubscribe = onDebugLogs(() => setLogs([...debugLogs]));
    return unsubscribe;
  }, []);

  if (!isDebugOn) return null;

  const last = logs[logs.length - 1];
  let color = "bg-muted";
  if (last?.status) {
    if (last.status >= 500) color = "bg-danger";
    else if (last.status >= 400) color = "bg-warning";
    else color = "bg-success";
  }

  return open ? (
    <div className="fixed left-2 right-2 bottom-2 z-50 max-h-60 overflow-y-auto bg-surface border text-xs p-2 space-y-2 shadow">
      <div className="flex justify-between items-center mb-2">
        <div className={`w-3 h-3 rounded-full ${color}`}></div>
        <button className="bg-text text-bg text-xs px-1 rounded" onClick={() => setOpen(false)}>
          Hide
        </button>
      </div>
      {logs.map((l, i) => (
        <div key={i} className="border-t pt-1">
          <div>
            {new Date(l.ts).toLocaleTimeString()} {l.method} {l.url}
          </div>
          {l.status && <div>Status: {l.status}</div>}
          {l.requestHeaders && <div>Req: {JSON.stringify(l.requestHeaders)}</div>}
          {l.responseHeaders && <div>Res: {JSON.stringify(l.responseHeaders)}</div>}
          {l.error && <div className="text-danger">Error: {l.error}</div>}
          {l.bodyPreview && <pre className="whitespace-pre-wrap break-all">{l.bodyPreview}</pre>}
        </div>
      ))}
    </div>
  ) : (
    <div className="fixed left-2 bottom-2 z-50 flex items-center space-x-2">
      <div className={`w-3 h-3 rounded-full ${color}`}></div>
      <button className="bg-text text-bg text-xs px-1 rounded" onClick={() => setOpen(true)}>
        Show
      </button>
    </div>
  );
}
